<script setup>
import { computed, ref } from 'vue';
import { formatDistance } from '../utils/distance';
import { getDealerStatus } from '../composables/useDealers';
import { t } from '../i18n';

const props = defineProps({
	dealer: { type: Object, required: true },
});

const emit = defineEmits(['select', 'view-details']);

const status = computed(() => getDealerStatus(props.dealer));

const directionsUrl = computed(() => {
	const q = encodeURIComponent(props.dealer.address || `${props.dealer.lat},${props.dealer.lng}`);
	return `https://www.google.com/maps/dir/?api=1&destination=${q}`;
});
</script>

<template>
	<article class="dealer-card">
		<header class="dealer-card__header">
			<h3 class="dealer-card__name">{{ dealer.name }}</h3>
			<span v-if="Number.isFinite(dealer.distance)" class="dealer-card__distance">
				{{ formatDistance(dealer.distance) }}
			</span>
		</header>

		<div class="dealer-card__info">
			<div class="dealer-card__address">
				{{ dealer.address }}
			</div>

			<div v-if="status" class="dealer-card__status">
				<span class="dealer-card__status-dot"
					:class="status.isOpen ? 'dealer-card__status-dot--open' : 'dealer-card__status-dot--closed'"></span>
				<span class="dealer-card__status-text">{{ status.label }}</span>
			</div>
		</div>

		<div class="dealer-card__actions">
			<a :href="directionsUrl" target="_blank" rel="noopener noreferrer" class="dealer-card__btn dl-btn dl-btn--primary"
				@click.stop>
				{{ t.openInGoogleMaps }}
			</a>

			<button type="button" class="dealer-card__btn dl-btn dl-btn--ghost" @click.stop="emit('view-details', dealer)">
				{{ t.viewDetails }}
			</button>
		</div>


	</article>
</template>
